import { BoxProps } from '@chakra-ui/react'

import { asPrice } from 'src/lib/utils'

import OverlayAction from './OverlayAction/OverlayAction'

const Cost = ({
  purchaseDate,
  price,
  ...props
}: {
  purchaseDate?: string
  price: number
} & BoxProps) => {
  if (purchaseDate) {
    return null
  }
  return (
    <OverlayAction {...props} px={3} py={1}>
      {price ? asPrice(price) : 'Free'}
    </OverlayAction>
  )
}

export default Cost
